// extracted by mini-css-extract-plugin
export var divider = "_uu-0";